import React, { useState } from 'react';
import { Paper, Typography, TableContainer, Table, TableBody, TableHead, TableCell, TableRow, Card, CardHeader, ToggleButton, ToggleButtonGroup, Stack } from '@mui/material';
import { BarChart, Dataset, Unsubscribe } from '@mui/icons-material';
import renderPercentage from '../renderPercentage';
import ReportsCardContent from './ReportsCardContent';
import UnsubscribeFeedbackChart from '../../account/feedback/UnsubscribeFeedbackChart';
import TypedValue from '../../TypedValue';
import { useTheme } from '@mui/material/styles';
import { lighten } from '@mui/system';

const Unsubscribes = ({ total, system, feedback, selected, onChangeSubscriberStatusFilter }) => {
    const theme = useTheme();
    const [isChartView, setIsChartView] = useState(false);
    const chartHeight = 180;

    const handleChange = (event, value) => {
        value !== null && setIsChartView(value);
    };

    const recipientUnsubscribes = total > 0 ? total - system : 0;

    return (
        <Card sx={{ height: '100%' }}>
            <CardHeader
                sx={{
                    m: 0,
                    py: 1,
                    '& .MuiCardHeader-action': {
                        alignSelf: 'center'
                    }
                }}
                slotProps={{
                    title: {
                        variant: 'h6',
                        fontWeight: 'normal'
                    }
                }}
                avatar={<Unsubscribe />}
                title="Unsubscribes"
                action={(
                    <ToggleButtonGroup
                        size="small"
                        color="primary"
                        value={isChartView}
                        disabled={feedback.length === 0}
                        exclusive
                        onChange={handleChange}
                        aria-label="View"
                        sx={{
                            mr: 1
                        }}
                    >
                        <ToggleButton value={false}><Dataset fontSize="inherit" /></ToggleButton>
                        <ToggleButton value={true}><BarChart fontSize="inherit" /></ToggleButton>
                    </ToggleButtonGroup>
                )}
            />
            {isChartView ? (
                <UnsubscribeFeedbackChart
                    feedback={feedback}
                    chartHeight={chartHeight}
                    padding={theme.spacing(4)}
                />
            ) : (
                <ReportsCardContent>
                    <Stack spacing={2}>
                        <Paper variant="outlined" sx={{ backgroundColor: lighten(theme.palette.primary.main, 0.9) }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow
                                            hover
                                            onClick={() => onChangeSubscriberStatusFilter('unsubscribed')}
                                        >
                                            <TableCell variant="head">
                                                Total
                                            </TableCell>
                                            <TableCell align="right" width="30%">
                                                <Typography variant="h6" color="primary">
                                                    <TypedValue value={total} type="number" accuracy={0} />
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right" width="20%">
                                                {renderPercentage(total, selected)}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        <Paper variant="outlined">
                            <TableContainer>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell variant="head">
                                                Recipient
                                            </TableCell>
                                            <TableCell align="right" width="30%">
                                                <Typography variant="h6" color="primary">
                                                    <TypedValue value={recipientUnsubscribes} type="number" accuracy={0} />
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right" width="20%">
                                                {renderPercentage(recipientUnsubscribes, selected)}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell variant="head">
                                                System
                                            </TableCell>
                                            <TableCell align="right" width="30%">
                                                <Typography variant="h6" color="primary">
                                                    <TypedValue value={system} type="number" accuracy={0} />
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="right" width="20%">
                                                {renderPercentage(system, selected)}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                        {feedback.length !== 0 && (
                            <Paper variant="outlined">
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    Feedback
                                                </TableCell>
                                                <TableCell align="right">
                                                    Submissions
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {feedback
                                                .map((feedback, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>
                                                            {feedback.feedbackText}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <TypedValue value={feedback.total} type="number" accuracy={0} />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        )}
                    </Stack>
                </ReportsCardContent>
            )}
        </Card>
    );
};

export default Unsubscribes;